import { Component, ReactNode } from 'react';
import { datadogRum } from '@datadog/browser-rum';

type FallbackRender = (error: Error) => ReactNode;

interface Props {
  children: ReactNode;
  fallback?: ReactNode;
  fallbackRender?: FallbackRender;
}

interface State {
  hasError: boolean;
  error?: Error;
}

class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  override componentDidCatch(error: Error) {
    datadogRum.addError(error);
    if (window.Rollbar) {
      window.Rollbar.error(error);
    }
  }

  override render() {
    const { fallback, fallbackRender, children } = this.props;
    const { hasError, error } = this.state;

    if (hasError) {
      if (fallbackRender && error) {
        return fallbackRender(error);
      }
      return fallback || <h1>Something went wrong.</h1>;
    }

    return children;
  }
}

export default ErrorBoundary;
